<template>
    <div class="rounded rounded-t-lg  shadow p-4">
        <div class="">
            <label class="block text-sm ">Current Password <span class="text-red-700">*</span></label>
            <input aria-label="Your Password" type="password" required v-model="oldPassword" class="appearance-none rounded-md relative block w-full px-3 py-2 border
                                       border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none
                                       focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
                   placeholder="Old Password"/>
        </div>
        <div class="flex my-3 justify-between">
            <div class="flex-1 mr-2">
                <label class="block text-sm leading-5 ">New Password <span class="text-red-700">*</span></label>
                <input aria-label="New Password"  type="password" required v-model="newPassword" class="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900
                      rounded-b-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
                       placeholder="New Password"/>
            </div>
            <div class="flex-1 ml-2">
                <label class="block text-sm leading-5 ">Confirm Password <span class="text-red-700">*</span></label>
                <input aria-label="Confirm Password" type="password" required v-model="newPasswordConfirm" class="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900
                      rounded-b-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
                       placeholder="Confirm password"/>
            </div>
        </div>
        <div class="mt-6">
            <button type="submit" v-on:click="updatePassword" class="rounded px-4 md:px-5 xl:px-4 py-2  bg-teal-500 hover:bg-teal-600 md:text-lg leading-tight
                       xl:text-base text-white">
                Update Password
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ResetPassword",
        data() {
            return {
                errors: [],
                oldPassword: null,
                newPassword: null,
                newPasswordConfirm: null
            }
        },

        watch: {
            errors: function (errors) {
                this.$root.$emit('alert_error', errors);
            }
        },
        methods: {
            updatePassword: function () {
                this.loading = true;
                this.errors = [];
                this.successes = [];
                if (this.oldPassword == null || this.oldPassword === '')
                    this.errors.push("Old Password field is required.");
                if (this.newPassword == null || this.newPassword === '')
                    this.errors.push("New password field is required.");
                if (this.newPasswordConfirm == null || this.newPasswordConfirm === '')
                    this.errors.push("New password confirmation field is required.");
                if (this.errors.length > 0) {
                    this.loading = false;
                    return;
                }

                this.axios.put(process.env.VUE_APP_SERVER_URL + '/api/v1/profile/password', {
                    old_password: this.oldPassword,
                    password: this.newPassword,
                    password_confirmation: this.newPasswordConfirm,
                }).then((result) => {
                    this.$root.$emit('alert_success', [result.data.data]);
                }).catch((error) => {
                    if (error.response != null) {
                        if (error.response.status === 422) {
                            this.errors.push(error.response.data.error.message);
                        }
                        else if (error.response.status === 401)
                            this.errors.push(error.response.data.error.message);
                    } else
                        this.errors.push("An error occurred while connecting to server")
                }).finally(() => {
                    this.loading = false;
                });
            }
        }
    }
</script>

<style scoped>

</style>